import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './page/HomePage';
import OrderHistory from './page/OrderHistory';
import TrackingPage from './page/TrackingPage';
import ProfilePage from './page/ProfilePage';
import TrackOrderPage from './page/TrackOrderPage';
import { StoreProvider } from './context/StoreContext';

function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/order-history" element={<OrderHistory />} />
          <Route path="/tracking/:orderId" element={<TrackingPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/track-order" element={<TrackOrderPage />} />
        </Routes>
      </BrowserRouter>
    </StoreProvider>
  );
}

export default App;